export const howWorksPickUp = [
  'ubs-homepage.pick-up-service.how-it-works.content.li_1',
  'ubs-homepage.pick-up-service.how-it-works.content.li_1.1',
  'ubs-homepage.pick-up-service.how-it-works.content.li_1.2',
  'ubs-homepage.pick-up-service.how-it-works.content.li_1.3',
  'ubs-homepage.pick-up-service.how-it-works.content.li_2',
  'ubs-homepage.pick-up-service.how-it-works.content.li_3'
];

export const courierPickUp = [
  'ubs-homepage.pick-up-service.courier.content.li_1',
  'ubs-homepage.pick-up-service.courier.content.li_1.1',
  'ubs-homepage.pick-up-service.courier.content.li_1.2',
  'ubs-homepage.pick-up-service.courier.content.li_2',
  'ubs-homepage.pick-up-service.courier.content.li_2.1',
  'ubs-homepage.pick-up-service.courier.content.li_2.2',
  'ubs-homepage.pick-up-service.courier.content.li_3',
  'ubs-homepage.pick-up-service.courier.content.li_3.1'
];

export const pricePickUp = [
  'ubs-homepage.pick-up-service.price.title',
  'ubs-homepage.pick-up-service.price.li_1',
  'ubs-homepage.pick-up-service.price.li_2',
  'ubs-homepage.pick-up-service.price.li_3'
];

export const extraoffer = [
  'ubs-homepage.pick-up-service.extraoffer.items.li_1',
  'ubs-homepage.pick-up-service.extraoffer.items.li_2',
  'ubs-homepage.pick-up-service.extraoffer.items.li_3',
  'ubs-homepage.pick-up-service.extraoffer.items.li_4',
  'ubs-homepage.pick-up-service.extraoffer.items.li_5'
];

export const minimumVolume = ['ubs-homepage.pick-up-service.minimum-volume.li_1', 'ubs-homepage.pick-up-service.minimum-volume.li_2'];

export const conditions = ['ubs-homepage.pick-up-service.conditions.item_1', 'ubs-homepage.pick-up-service.conditions.item_2'];
